import React from 'react'
import { App, Button } from 'antd'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import { useFinishRefinementMutation } from '../../../../../../../store/apis/rubric-refinement.api'
import { buildAssignmentPath } from '../../../../../../../utils/link.helper'
import { useVersionId } from '../../../../../../../utils/parseURL.helper'
import { AssignmentSections } from '../../../../../../../constants/assignment-sections'
import { CheckOutlined } from '@ant-design/icons'
import { useThemeColors } from '../../../../../../../hooks/useThemeColors'

const FinishRefinementButton = props => {
    const { modal } = App.useApp()
    const colors = useThemeColors()
    const navigate = useNavigate()
    const refinementProcess = useSelector(rubricRefinementSelectors.refinementProcess)
    const [finishRefinement, { isLoading: isFinishingRefinement }] = useFinishRefinementMutation()
    const { token, layerId } = useParams()
    const versionId = useVersionId()

    const { hasApprovedSuggestions, isAllItemsReviewed, ...buttonProps } = props

    const handleFinish = async () => {
        if (!hasApprovedSuggestions) {
            navigate(buildAssignmentPath(token, layerId, AssignmentSections.HOME, versionId))
            return
        }

        modal.confirm({
            title: 'Apply Refinements to Rubric?',
            icon: null,
            content: `This will apply all accepted refinements to the current rubric and retrain the model.`,
            okText: 'Apply',
            okType: 'primary',
            okButtonProps: { 'data-test': 'refinement-apply-modal-confirm' },
            onOk: async () => {
                if (refinementProcess?.id) {
                    try {
                        const response = await finishRefinement({id: refinementProcess.id, token, versionId, questionRubricId: layerId}).unwrap()
                        if (response?.versionId && response?.questionRubricId) {
                            navigate(buildAssignmentPath(token, response.questionRubricId, AssignmentSections.HOME, response.versionId))
                        } else {
                            navigate(buildAssignmentPath(token, layerId, AssignmentSections.HOME, versionId))
                        }
                    } catch (error) {
                        console.error('Error applying refinements:', error)
                    }
                }
            }
        })
    }

    const buttonText = hasApprovedSuggestions ? 'Apply Changes' : 'OK'
    const isEnabled = isAllItemsReviewed

    return (
        <Button 
            onClick={handleFinish}
            loading={isFinishingRefinement}
            icon={<CheckOutlined />}
            style={{ color: props.type === 'primary' || !isEnabled ? undefined : colors.success }}
            disabled={!isEnabled}
            data-test='refinement-finish-button'
            {...buttonProps}
        >
            {buttonText}
        </Button>
    )
}

export default FinishRefinementButton 